import { getABTProvider } from './statsig'
export {
  initialize as initializeAbtProvider,
  getABTProvider,
  updateUser,
  logSessionReplayGateStatus,
} from './statsig'
export default {
  install(Vue) {
    const service = getABTProvider()
    Vue.prototype.$abtProvider = service
  },
}
